import { create } from "zustand";
import { devtools } from "zustand/middleware";

import { ISbpTransferTerm, MakeSbpTransferStatusType } from "../api/sbpTransfer/types.ts";

export interface ITransferResult {
  status: MakeSbpTransferStatusType;
  amount: string;
  term: ISbpTransferTerm | null;
  bankSchema: string;
  bankName: string;
}

export interface ISbpTransferState {
  amount: string;
  term: ISbpTransferTerm | null;
  bankSearch: string;
  selectedBankSchema: string;
  selectedBankName: string;
  transferResult: ITransferResult | null;

  setAmount: (newAmount: string) => void;
  setTerm: (newTerm: ISbpTransferTerm | null) => void;
  setBankSearch: (searchValue: string) => void;
  setSelectedBankSchema: (schema: string) => void;
  setSelectedBankName: (name: string) => void;
  setTransferResult: (result: ITransferResult | null) => void;

  reset: () => void;
}

const initialState = {
  amount: "",
  term: null,
  bankSearch: "",
  selectedBankSchema: "",
  selectedBankName: "",
  transferResult: null,
};

export const useSbpTransferStore = create<ISbpTransferState>()(
  devtools(set => ({
    ...initialState,
    setAmount: (newAmount) => {
      set({ amount: newAmount }, false, "sbp-transfer-store/setAmount");
    },
    setTerm: (newTerm) => {
      set({ term: newTerm }, false, "sbp-transfer-store/setTerm");
    },
    setBankSearch: (searchValue) => {
      set({ bankSearch: searchValue }, false, "sbp-transfer-store/setBankSearch");
    },
    setSelectedBankSchema: (schema) => {
      set({ selectedBankSchema: schema }, false, "sbp-transfer-store/setSelectedBankSchema");
    },
    setSelectedBankName: (name) => {
      set({ selectedBankName: name }, false, "sbp-transfer-store/setSelectedBankName");
    },
    setTransferResult: (result) => {
      set({ transferResult: result }, false, "sbp-transfer-store/setTransferResult");
    },
    reset: () => {
      set(initialState, false, "sbp-transfer-store/reset");
    },
  }),
  { name: "sbp-transfer-store" }),
);
